<template>
    <div v-if="showWarning" class="cultural-warning">
        <div class="cultural-warning__inner">
            <h2 class="h6 cultural-warning__heading">Cultural Warning</h2>

            <div class="richtext cultural-warning__body" v-html="message" />

            <button type="button" class="btn btn--primary mt-6" @click.prevent="onAgree">
                I Agree
            </button>
        </div>
    </div>

    <slot v-else />
</template>

<script>
    import { hasAgreed, setAgreed } from '@utils/cultural-warning';

    export default {
        props: {
            required: {
                type: Boolean,
                default: false,
            },
        },

        emits: ['agree'],

        data() {
            return {
                agreed: hasAgreed(),
                message: window.i18n.culturalWarning,
            };
        },

        computed: {
            showWarning() {
                return this.required && !this.agreed;
            },
        },

        methods: {
            onAgree() {
                setAgreed();
                this.agreed = true;
                this.$emit('agree');
            },
        },
    };
</script>
